var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"WorldMap"},[_c('MapBox',{staticClass:"MapBox__wrapper",attrs:{"accessToken":_vm.accessToken,"mapStyle":_vm.mapStyle,"options":_vm.options},on:{"load":_vm.onMapLoaded}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }